module.exports = __webpack_public_path__ + "static/media/om_beard_long_round__oval.ea087bf5.png";